function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Combined Shape");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "manuscript",
  transform: "translate(-3.000000, 0.000000)",
  fill: "#3B3A42",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M9,2.00012263 L9,6.5 C9,6.77671525 9.22328475,7 9.5,7 C9.77671525,7 10,6.77671525 10,6.5 L10,6 L12,6 L12,6.5 C12,7.88128475 10.8812847,9 9.5,9 C8.11871525,9 7,7.88128475 7,6.5 L7,2.00007195 L5.0802229,2.0000233 C5.03232157,2.00115039 4.9999463,2.03447974 5.0007,2.08734793 L5.00054375,5.3473948 L5.00019994,12.5208481 L4.99985623,19.6930355 C4.99973124,22.3014185 4.99973124,22.3014185 4.99958208,22.9696566 C4.99910062,23.0010051 5.02919944,23.0316941 5.0567,23.0323 L19.9744604,23.0323 C19.9740041,23.0126115 19.9735491,22.9887793 19.9727,22.9443 L19.9727,7.0083 L20.4603022,7.0083 L20.4484211,6.99611295 L16.5275938,6.99596244 C15.2038184,7.02049575 14.0852603,6.01485228 14,4.64015753 L14,2.00024933 L9,2.00012263 Z M7,0 L11,0 L16.421379,0.0003 L24.9997,8.79951272 L24.9997,9.2063 L24.9995569,25.8963819 C25.0189493,27.0424733 24.0989473,27.9809708 22.9347,28.0003 L8.0837,28.0003 C7.23204467,28.0003 6.60329195,27.5665326 6.27336736,26.9033231 C6.09366516,26.5420884 6.0277,26.1757462 6.0277,25.9133 L6.0277,25.0321672 L5.03983899,25.0321578 C3.8979268,25.0129013 2.98230353,24.0793246 2.9997,22.9543 L2.99985623,19.6929397 L3.0002,12.5196271 L3.00054375,5.34729895 C3.00066875,2.73925207 3.00066875,2.73925207 3.00084458,2.10430434 C2.9814517,0.964002483 3.89119757,0.0274468083 5.0567,0.0003 L7,0.0003 Z M15.9991942,2.43231849 L15.9979909,4.57679938 C16.0127816,4.80977673 16.2257133,5.0012137 16.5090642,4.99613413 L18.4986489,4.99613413 L15.9991942,2.43231849 Z M22.9997,9.61308728 L21.9726861,8.55962773 L21.9725569,22.9273819 C21.9737621,22.9839968 21.9737621,22.9839968 21.975707,23.0477607 C21.9948059,23.6682315 21.967186,23.9324907 21.6928356,24.326064 C21.33641,24.8373794 20.7673918,25.0323 19.9997,25.0323 L8.0277,25.0321862 L8.0277,25.9133 C8.0277,25.9524838 8.05148695,26.0003 8.0837,26.0003 L22.9179799,26.0004398 C22.9670402,25.9996194 23.0004409,25.9655472 22.9997,25.9133 L22.9997,9.61308728 Z",
  id: "Combined-Shape"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "22px",
    height: "28px",
    viewBox: "0 0 22 28",
    version: 1.1
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/manuscript.e317640b.svg";
export { SvgComponent as ReactComponent };